import { useEffect, useMemo, useState } from 'react';
import { useIsMounted } from 'seagull';
import { useStateInRef } from 'seagull/utils/useStateInRef';
import { useIoContext } from '~/contexts';
import { retryCountdownSeconds } from './network-retry-schedule';
export function useNetworkRetry(param) {
    let { active, attempt, schedule } = param;
    const { browser } = useIoContext();
    const [failedAttempts, setFailedAttempts] = useState(0);
    const [isRetrying, setIsRetrying] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(()=>retryCountdownSeconds(0, schedule.random(), schedule));
    const flight = useMemo(()=>({
            inFlight: false
        }), []);
    const isMounted = useIsMounted();
    const getRunAttempt = useStateInRef(runAttempt);
    useEffect(()=>{
        if (active && !isRetrying) {
            const countdown = {
                remaining: retryCountdownSeconds(failedAttempts, schedule.random(), schedule)
            };
            setSecondsLeft(countdown.remaining);
            const stopTicker = schedule.startTicker(()=>{
                countdown.remaining -= 1;
                setSecondsLeft(countdown.remaining);
                if (countdown.remaining <= 0) {
                    stopTicker();
                    void getRunAttempt()({
                        resetBackoff: false
                    });
                }
            });
            return stopTicker;
        }
    }, [
        active,
        isRetrying,
        failedAttempts,
        schedule
    ]);
    useEffect(()=>{
        if (active) {
            return browser.registerOnlineListener(()=>void getRunAttempt()({
                    resetBackoff: true
                }));
        }
    }, [
        active
    ]);
    async function runAttempt(param) {
        let { resetBackoff } = param;
        if (flight.inFlight) return;
        flight.inFlight = true;
        setIsRetrying(true);
        await attempt().catch(()=>{});
        flight.inFlight = false;
        if (isMounted()) {
            setFailedAttempts((count)=>resetBackoff ? 0 : count + 1);
            setIsRetrying(false);
        }
    }
    function retryNow() {
        void getRunAttempt()({
            resetBackoff: true
        });
    }
    return {
        isActive: active,
        isRetrying,
        secondsLeft,
        retryNow
    };
}
